import type { CSSObject } from '@emotion/react'
import { MapControlsPanel } from 'components/MapControlsPanel/MapControlsPanel'
import type { FC } from 'react'
import { layersNavigationMenuStore } from 'stores/layersNavigationMenuStore/layersNavigationMenuStore'
import { smallStore, useScreenOrientation } from 'stores/smallStore/smallStore'
import UAParser from 'ua-parser-js'
import { useIsWideScreen } from 'utils/useIsWideScreen'
import { usePreventPanelDetailsFromBeingOpen } from 'utils/usePreventPanelDetailsFromBeingOpen'
import { SharedSettings } from '../../../settings/SharedSettings'
import { MapControlItems } from './MapControlItems/MapControlItems'
import { ValueRow } from './ValueRow/ValueRow'

const { SPACING_WHEN_MENU_COLLAPSED, SPACING_WHEN_MENU_OPEN } =
  SharedSettings.SPACING_FOR_THINGS_THAT_FLOAT_OVER_LEFT_SIDE_OF_MAP

export const MapControls: FC = () => {
  const isWideScreen = useIsWideScreen()
  const screenOrientation = useScreenOrientation()
  const menuCollapsed = layersNavigationMenuStore.useSelector((s) => s.menuCollapsed)
  const preventPanelDetailsFromBeingOpen = usePreventPanelDetailsFromBeingOpen()
  const leftSpacing = menuCollapsed ? SPACING_WHEN_MENU_COLLAPSED : SPACING_WHEN_MENU_OPEN
  const collapsedBottomPanelHeight = 60
  const isCollapsedBottomPanel = screenOrientation === 'landscape' && !isWideScreen
  const isPropertyPlaybackActive = smallStore.useSelector((s) => s.showPropertyPlayback)
  const deviceType = new UAParser(window.navigator.userAgent)?.getDevice()?.type
  const isMobileOrTablet = deviceType === 'mobile' || deviceType === 'tablet'

  const topSpacing = isPropertyPlaybackActive
    ? 'calc(130px + env(safe-area-inset-top))'
    : 'calc(60px + env(safe-area-inset-top))'

  const wideScreenContainerStyle: CSSObject = {
    left: isPropertyPlaybackActive ? SPACING_WHEN_MENU_COLLAPSED : leftSpacing,
    top: menuCollapsed ? 'calc(132px + env(safe-area-inset-top))' : topSpacing,
  }

  const narrowScreenBottomSpacing = isMobileOrTablet ? 70 : 10

  const narrowScreenContainerStyle: CSSObject = {
    left: 10,
    bottom: isPropertyPlaybackActive ? 170 : narrowScreenBottomSpacing,
    marginBottom: preventPanelDetailsFromBeingOpen || isCollapsedBottomPanel ? 0 : collapsedBottomPanelHeight,
  }

  return (
    <MapControlsPanel
      style={
        screenOrientation === 'landscape' && isWideScreen
          ? wideScreenContainerStyle
          : narrowScreenContainerStyle
      }
      expandedContent={<MapControlItems />}
      isPropertyPlaybackActive={isPropertyPlaybackActive}
    >
      <ValueRow />
    </MapControlsPanel>
  )
}
